// Legacy tool for draft mode
import { atom } from "jotai";
import { parseCanvasDataFromZSL } from "@zapier/streaming";
import { z } from "zod";
/**
 * TEMPORARY TYPE DECLARATION
 * This is a temporary solution to fix type errors with @zapier/zsl-creator-schemas
 * This should be replaced with proper type declarations from the package in the future
 */
// @ts-ignore
import { ZslSchemaForApi } from "@zapier/zsl-creator-schemas";
import {
  canvasAtom,
  edgesAtom,
  nodesAtom,
  zslAtom,
} from "@zapier/canvas-state";

import { JotaiTool } from "../../index";

const EDITABLE_ASSETS = "table, interface, agents, and chatbot";

export const editSystemAtom = atom<JotaiTool<z.infer<typeof ZslSchemaForApi>>>(
  () => ({
    name: "edit_system",
    description: `This tool is used to:
      - Edit ${EDITABLE_ASSETS} assets.
      - Add new ${EDITABLE_ASSETS}s.
      - Remove any assets.

      ## Important
      This tool should not be used to:
      - Edit or add zaps.
      - Existing zaps MUST be preserved unchanged in your response.

      When calling this tool, make sure to provide the entire new system including:
      1. Your edits to ${EDITABLE_ASSETS}s
      2. All existing zaps exactly as they are (do not modify or omit them)
      3. Any other existing components that should be preserved

      Your response must contain the complete system state, not just the changed parts.
      `,
    parameters: ZslSchemaForApi,
    execute: atom(
      null,
      async (get, set, { args: editedZsl, reactFlowInstance }) => {
        const canvas = get(canvasAtom);
        const nodes = get(nodesAtom);
        const edges = get(edgesAtom);

        set(zslAtom, editedZsl);
        const nodesAndEdges = parseCanvasDataFromZSL(editedZsl, {
          canvas: {
            name: canvas.name || "Untitled Canvas",
            description: canvas.description || "",
            nodes: nodes as any,
            edges: edges as any,
          },
          warnings: [],
        });
        if (nodesAndEdges) {
          const {
            canvas: { nodes, edges },
          } = nodesAndEdges;
          set(nodesAtom, nodes as any);
          set(edgesAtom, edges as any);
          reactFlowInstance.fitView();
        }
        return {
          content: [{ type: "text", text: "Canvas updated" }],
        };
      },
    ),
  }),
);
editSystemAtom.debugLabel = "editSystemAtom";
